var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { twMerge } from 'tailwind-merge';
export var SidebarList = function (props) {
    var _a = useState((props.currentPath || '').includes(props.path)), showSubItems = _a[0], setShowSubItems = _a[1];
    return (_jsxs("div", __assign({ className: "flex h-fit flex-col" }, { children: [_jsxs("div", __assign({ className: "flex w-full cursor-pointer flex-row items-center justify-between py-[14px] pl-[24px] pr-[13px]", onClick: function () { return setShowSubItems(!showSubItems); } }, { children: [_jsxs("div", __assign({ className: "flex flex-row items-center gap-[16px] text-sm font-normal leading-5 tracking-tight text-[#383838]" }, { children: [props.icon && _jsx(props.icon, { size: '20px' }), props.label] })), _jsx(FaChevronDown, { className: twMerge('size-[16px] cursor-pointer fill-[#6F7276] transition duration-[0.2]', showSubItems ? '-rotate-180' : 'rotate-0') })] })), _jsx("div", __assign({ className: "flex flex-col" }, { children: showSubItems && props.children }))] })));
};
